export const RoutePaths = {
  Base: 'fortress',
  Roles: 'roles',
  Users: 'users',
  Permissions: 'permissions',
} as const;
